module.exports = __webpack_public_path__ + "img/05.b634ccb3.png";